import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class NotificationService {
  public notify = new EventEmitter<void>();
}